import React from "react";

const Google = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 533.5 544.3" role="img">
      <path
        fill="#4285F4"
        d="M533.5 278.4c0-18.5-1.5-37-4.7-54.9H272v103.9h146.9c-6.3 34.4-25.1 63.5-53.8 82.9v68h86.9c50.9-46.9 81.5-116 81.5-199.9z"
      />
      <path
        fill="#34A853"
        d="M272 544.3c72.9 0 134.2-24.1 178.9-65.4l-86.9-68c-24.1 16.1-55 25.1-92 25.1-70.6 0-130.5-47.5-151.9-111.3H30.5v69.9c44.2 87.8 135.3 149.7 241.5 149.7z"
      />
      <path
        fill="#FBBC05"
        d="M120.1 324.7c-11.5-34.4-11.5-71.6 0-106l-69.6-69.9C18.1 187.3 0 229.2 0 272c0 42.8 18.1 84.7 50.5 123.2l69.6-70.5z"
      />
      <path
        fill="#EA4335"
        d="M272 107.7c39.8-.6 77.3 14.1 106.4 41.1l79.3-79.3C406.2 24.1 344.9 0 272 0 165.7 0 74.6 61.9 30.5 149.7l89.6 69.9c21.4-63.8 81.3-111.9 151.9-111.9z"
      />
    </svg>
  );
};
export default Google;
